import { putApiGalaxyServer, postApiGalaxyServer, getApiGalaxyServer } from 'services';
import { UpdateTeamParams } from 'ProfileModule/types';
import {
  FetchDataToIntegrationServerApiParams,
  FetchActiveTeamsPayload,
} from 'ReportsModule/types';
import { FetchTeamApiTokenPayload } from 'TeamModule/types';

export const getSuperAdmins = (config = {}, token = '') =>
  getApiGalaxyServer(`/rails_api/teams/super_admins`, config, token);

export const fetchDataToIntegrationServer = (
  { dataType, targetServiceId }: Omit<FetchDataToIntegrationServerApiParams, 'fetchFrom'>,
  config = {},
  token = '',
) => {
  return getApiGalaxyServer(
    `/integrations_api/fetch-data/${dataType}/${targetServiceId}`,
    config,
    token,
  );
};

type IntegrationForceUpdateApiParams = {
  mosaicTeamId: number;
  targetServiceId: number;
};

type IntegrationForceUpdateApiBody = {
  dataType: string;
  targetSide: boolean;
  ignoreWaitingResponse: boolean;
};

export const integrationServerForceUpdate = (
  { mosaicTeamId, targetServiceId }: IntegrationForceUpdateApiParams,
  body: IntegrationForceUpdateApiBody,
  config = {},
  token = '',
) =>
  postApiGalaxyServer(
    `/integrations_api/mappings/utils/force-update/${mosaicTeamId}/${targetServiceId}`,
    body,
    config,
    token,
  );

export const updateTeam = (
  data: UpdateTeamParams,
  token: string,
  config: Record<string, any> = {},
) => putApiGalaxyServer(`/rails_api/team`, data, config, token);

export const fetchTeamApiToken = ({
  params,
  token,
  config,
}: BaseApiParams<FetchTeamApiTokenPayload>) =>
  postApiGalaxyServer(`/rails_api/integrations/auth/key`, params, config, token);

export const reactivateTeam = ({ teamId }: { teamId: number }, config = {}, token: string) =>
  postApiGalaxyServer(`/rails_api/teams/${teamId}/reactivate`, {}, config, token);

export const getActiveTeams = ({ params, token, config }: BaseApiParams<FetchActiveTeamsPayload>) =>
  getApiGalaxyServer(`/rails_api/get_active_teams`, { ...config, params }, token);
